import { useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
 
const tabs = [
  {
    id: "operations",
    title: "Operations",
    subtitle: "Shipping, BL & Container",
    icon: <Inventory2OutlinedIcon sx={{ fontSize: 42 }} />,
    color: "#2563eb",
    bg: "#EEF4FF",
  },
  {
    id: "commercial",
    title: "Commercial",
    subtitle: "Purchase, Sales & Invoice",
    icon: <BusinessCenterOutlinedIcon sx={{ fontSize: 42 }} />,
    color: "#16A34A",
    bg: "#F0FDF4",
  },
  {
    id: "documents",
    title: "Documents",
    subtitle: "Upload & Generate Files",
    icon: <DescriptionOutlinedIcon sx={{ fontSize: 42 }} />,
    color: "#EA580C",
    bg: "#FFF7ED",
  },
];
 
export default function SectionTabs({ handleCardClick }) {
  const [active, setActive] = useState("operations");
 
  const handleClick = (id) => {
    setActive(id);
    handleCardClick(id);
  };
 
  return (
    <>
      <style>{`
        .module-card{
          transition:all .35s ease;
        }
 
        .module-card:hover{
          transform:translateY(-8px);
          box-shadow:0 18px 35px rgba(0,0,0,.12)!important;
        }
 
        .module-card:hover .arrow{
          transform:translateX(6px);
        }
 
        .arrow{
          transition:.3s;
        }
      `}</style>
 
      <div className="py-4">
        <div className="row g-4">
          {tabs.map((item) => (
            <div className="col-lg-4 col-md-6" key={item.id}>
              <div
                className="module-card"
                onClick={() => handleClick(item.id)}
                style={{
                  cursor: "pointer",
                  borderRadius: 20,
                  background: "#fff",
                  padding: 30,
                  height: "100%",
                  border:`2px solid ${item.color}`,
                  boxShadow: "0 8px 24px rgba(0,0,0,.08)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Top Border */}
 
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: 5,
                    background: item.color,
                  }}
                />
 
                {/* Icon */}
 
                <div
                  style={{
                    width: 82,
                    height: 82,
                    borderRadius: 20,
                    background: item.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: item.color,
                  }}
                >
                  {item.icon}
                </div>
 
                <h4
                  style={{
                    marginTop: 24,
                    fontWeight: 700,
                    color: "#1f2937",
                  }}
                >
                  {item.title}
                </h4>
 
                <p
                  style={{
                    color: "#6b7280",
                    fontSize: 15,
                    minHeight: 42,
                  }}
                >
                  {item.subtitle}
                </p>
 
                <div
                  style={{
                    marginTop: 25,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: item.color,
                      fontWeight: 600,
                    }}
                  >
                    Explore
                  </span>
 
                  <ArrowForwardRoundedIcon
                    className="arrow"
                    sx={{
                      color: item.color,
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}